/**
 * Cookie consent state — gestisce il consenso GDPR per il tracking.
 *
 * Categorie di cookie:
 *  - necessary: sempre attivi (auth, CSRF, preferenze tecniche). Non bloccabili.
 *  - analytics: GA4 (non installato attualmente, predisposto)
 *  - marketing: Meta Pixel + remarketing. RICHIEDE consenso esplicito.
 *
 * Storage: localStorage key `cookie_consent_v1` (versione per invalidare se cambia la policy).
 * Forma: `{ marketing: true|false, analytics: true|false, ts: "2026-..." }`
 *
 * Importante: questo modulo è SINCRONO — il check va fatto PRIMA di inizializzare
 * gli script di terze parti, altrimenti il consenso non serve a nulla.
 */

const STORAGE_KEY = "cookie_consent_v1";

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function hasConsentDecision() {
  return getConsent() !== null;
}

export function hasMarketingConsent() {
  const c = getConsent();
  return Boolean(c && c.marketing);
}

export function hasAnalyticsConsent() {
  const c = getConsent();
  return Boolean(c && c.analytics);
}

export function setConsent({ marketing = false, analytics = false }) {
  if (typeof window === "undefined") return;
  const data = {
    marketing: Boolean(marketing),
    analytics: Boolean(analytics),
    ts: new Date().toISOString(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    // Notifica listeners (es. analytics.js può inizializzare il pixel)
    window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: data }));
  } catch {
    /* ignore */
  }
}

export function acceptAll() {
  setConsent({ marketing: true, analytics: true });
}

export function rejectAll() {
  setConsent({ marketing: false, analytics: false });
}

export function revokeConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: null }));
    // Forza reload per smontare i pixel già caricati
    window.location.reload();
  } catch {
    /* ignore */
  }
}
